"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "NOTIFICATION_SEMANTIC", {
  enumerable: true,
  get: function () {
    return _Notification.NOTIFICATION_SEMANTIC;
  }
});
Object.defineProperty(exports, "Notification", {
  enumerable: true,
  get: function () {
    return _Notification.Notification;
  }
});
var _Notification = require("./Notification");